import React from "react";

export type MegaNavMobileContextType = {
  setActiveTabIndex: React.Dispatch<React.SetStateAction<number>>;
  activeTabIndex: number;
  activePanelIndex: number;
  mobileMenuOpen: boolean;
  setActivePanelIndex: React.Dispatch<React.SetStateAction<number>>;
  setMobileMenuOpen: React.Dispatch<React.SetStateAction<boolean>>;
  reset: () => void;
};
export const MegaNavMobileContext = React.createContext<MegaNavMobileContextType | null>(null);

export const MegaNavMobileContextProvider = ({ children }: { children: React.ReactNode }): React.JSX.Element => {
  const [activeTabIndex, setActiveTabIndex] = React.useState<number>(0);
  const [activePanelIndex, setActivePanelIndex] = React.useState<number>(-1);
  const [mobileMenuOpen, setMobileMenuOpen] = React.useState<boolean>(false);

  const handleReset = () => {
    setActiveTabIndex(0);
    setActivePanelIndex(-1);
  };

  const store = React.useMemo(
    () => ({
      activeTabIndex,
      setActiveTabIndex,
      setActivePanelIndex,
      activePanelIndex,
      reset: handleReset,
      mobileMenuOpen,
      setMobileMenuOpen,
    }),
    [activeTabIndex, setActiveTabIndex, activePanelIndex, setActivePanelIndex, mobileMenuOpen, setMobileMenuOpen]
  );

  return <MegaNavMobileContext.Provider value={store}>{children}</MegaNavMobileContext.Provider>;
};

export const useMegaNavMobileContext = () => {
  const context = React.useContext(MegaNavMobileContext);

  if (!context) {
    throw new Error("useMegaNavMobileContext must be used within an MegaNavMobileContext.Provider");
  }

  return context;
};
